import React from "react";

import "./styles.scss";
import { useMutation } from "@apollo/client";
import { Formik } from "formik";
import get from "lodash/get";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Button from "shared/components/Button";
import Input from "shared/components/Input";
import Logo from "shared/components/Logo";
import Notification from "shared/components/Notification";
import Space from "shared/components/Space";
import { RESET_PASSWORD } from "shared/graphql/mutations";
import { DEFAULT_VALUES, NAME_SPACES } from "shared/locals/constants";
import { PATHS } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";

import validation from "./validation";
import {PrivacyPolicyLink} from "../../../shared/components/PrivacyPolicyLink";

const SignIn = () => {
  const history = useHistory();
  const { t } = useTranslation(NAME_SPACES.AUTH);
  const { t: tError } = useTranslation(NAME_SPACES.ERRORS);

  const [resetPassword] = useMutation(RESET_PASSWORD, {
    onCompleted: async () => {
      history.push(PATHS.AUTH.SENT_EMAIL);
    },
    onError: (error) => {
      const _error = get(
        error.graphQLErrors,
        "[0].extensions.messages",
        tError("GENERIC"),
      );
      Notification.error({
        duration: DEFAULT_VALUES.NOTIFICATION_DURATION,
        message: _error,
      });
    },
  });

  return (
    <div className={"auth-page"}>
      <Logo width={128} />
      <Space h={54} />
      <div className={"form"}>
        <p className={"title"}>{t("NEW_PASSWORD")}</p>
        <Space h={44} />
        <p className={"desc"}>{t("FILL_EMAIL")}</p>
        <Space h={24} />
        <p className={"desc"}>{t("GET_EMAIL")}</p>
        <Formik
          initialValues={{ username: "" }}
          onSubmit={(data) => {
            resetPassword({
              variables: {
                data: {
                  ...data,
                },
              },
            });
          }}
          validationSchema={validation(
            t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
          )}>
          {({ handleSubmit, ...formProps }) => (
            <>
              <Input
                placeholder={t("LOGIN")}
                {...bindInputProps({ name: "username", ...formProps })}
              />
              <Space h={64} />
              <Button text={t("SEND")} fillWidth onClick={handleSubmit} />
            </>
          )}
        </Formik>
        <div><PrivacyPolicyLink/></div>
      </div>
    </div>
  );
};

export default SignIn;
